module["exports"] = [
  "######"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/address/postcode.js
 ** module id = 897
 ** module chunks = 0
 **/